module.exports = __webpack_public_path__ + "img/IMG_9122.50843303.jpg";